import { CallBackModel } from "./call-back.model";
import { DeathDetailModel } from "./death-detail.model";
import { DiagnoseModel } from "./diagnose.model";
import { GeneralModel } from "./general.model";

export class CaseModel {
  diagnoseDetail: DiagnoseModel = null;
  general: GeneralModel = null;
  death: DeathDetailModel = null;
  callBack: CallBackModel = null;
  caseDetailId: string = null;
}